<div class="row">
    <div class="col-6 col-md-5 mb-4">
		<div class="card rounded-top-left-0">
			<div class="card-header d-flex justify-start items-center gap-2">
				<h3>Listas de Destinos</h3>
				<span 
				class="a-hover font-bold text-primary cursor-pointer" 
				(click)="showModalCreate = true"
				tooltip="Agregar Lista">
					<i class="fa fa-plus"></i> Agregar Destino
				</span>
			</div>
			<div class="card-body">
				<app-destination-list-group (destinationEvent)="setCurrentDestination($event)" [saving]="saving"/>
			</div>
		</div>
	</div>
    <div class="col-1 col-md-7 mb-4">
		<div class="card">
			<div class="card-header">
				<h3>Bodegas Asignadas
					<span *ngIf="destinationSelected!=null" class="font-medium"> "{{destinationSelected.name}}"</span>
				</h3>
			</div>
			<div class="card-body">
				<app-destination-warehouses-list [destinationSelected]="destinationSelected"/>
			</div>
		</div>
	</div>
</div>

<app-modal-dialog 
*ngIf="showModalCreate" 
[show]="showModalCreate" 
[title]="'Agregar Destino'"
[showHeader]="true"
[size]="'md'"
(closed)="closeModal($event)"
>
	<div modal-body>
		<div class="input-group col mb-4">
			<input type="text" 
				placeholder="Nombre" 
				class="form-control"
				[(ngModel)]="destinationName"
			>
		</div>
		<div class="input-group col justify-end text-left">
			<ng-container *ngIf="loadingCreate">
				<button class="btn btn-success" [disabled]="loadingCreate">
					<i class="fa fa-spinner"></i> Agregando
				</button>
			</ng-container>
			<ng-container *ngIf="!loadingCreate">
				<button class="btn btn-success" (click)="addList()">
					<i class="fa fa-floppy-disk"></i> Agregar
				</button>
			</ng-container>
		</div>
	</div>

</app-modal-dialog>